import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/common/img/bana-toranomaki.png'
import _imports_1 from '@/assets/common/img/icon-t-check-s1.png'


const _withScopeId = n => (_pushScopeId("data-v-317c4845"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet1"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = {
  key: 2,
  id: "contents1"
}
const _hoisted_6 = { class: "com_tranomaki_title1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "営業「虎の巻」"
  })
], -1))
const _hoisted_8 = { class: "progress1" }
const _hoisted_9 = { class: "num1" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "error-message"
}
const _hoisted_12 = { class: "com_sec1" }
const _hoisted_13 = { class: "com_inner1 clearfix" }
const _hoisted_14 = { class: "com_toranomaki_content1" }
const _hoisted_15 = { class: "content1" }
const _hoisted_16 = { class: "hd1" }
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "step1 roboto" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "t1" }, "STEP", -1))
const _hoisted_20 = { class: "t2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rate1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("進捗率")
], -1))
const _hoisted_22 = { class: "num1 roboto" }
const _hoisted_23 = { class: "t1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "t2" }, "/ ", -1))
const _hoisted_25 = { class: "t3" }
const _hoisted_26 = { class: "body1" }
const _hoisted_27 = { class: "com_more_item1" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "copy1 roboto" }
const _hoisted_31 = { class: "copy2" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "もっと見る", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "content2 sticky-pane"
}
const _hoisted_36 = { class: "wrap1" }
const _hoisted_37 = { class: "cnt1" }
const _hoisted_38 = { class: "hd1" }
const _hoisted_39 = { class: "roboto" }
const _hoisted_40 = { class: "hd2" }
const _hoisted_41 = { class: "roboto" }
const _hoisted_42 = { class: "com_check_comp1" }
const _hoisted_43 = ["value", "checked"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkComplete" }, "完了", -1))
const _hoisted_45 = {
  key: 0,
  class: "com_slider1"
}
const _hoisted_46 = { class: "item1" }
const _hoisted_47 = {
  href: "#",
  class: "movie1"
}
const _hoisted_48 = ["src", "alt", "onClick"]
const _hoisted_49 = { class: "body1" }
const _hoisted_50 = {
  key: 0,
  class: "com_d_content1"
}
const _hoisted_51 = ["src", "alt"]
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = { key: 1 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "関連資料", -1))
const _hoisted_55 = { class: "list1" }
const _hoisted_56 = ["href", "onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { key: 2 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "関連リンク", -1))
const _hoisted_62 = { class: "list1" }
const _hoisted_63 = ["href", "onClick"]
const _hoisted_64 = {
  key: 1,
  class: "content2"
}
const _hoisted_65 = {
  key: 0,
  class: "wrap1"
}
const _hoisted_66 = { class: "cnt1" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd1" }, " ", -1))
const _hoisted_68 = { class: "body1" }
const _hoisted_69 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!
  const _component_slide = _resolveComponent("slide")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_header_component)
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isModalOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal-overlay",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_VideoPlayer, {
              videoSrc: `/${_ctx.selectedVideo?.videoPath}/${_ctx.selectedVideo?.videoName}`,
              contentsId: _ctx.contentsData.contentsId,
              screenName: "CarouselScreen"
            }, null, 8, ["videoSrc", "contentsId"]),
            _createElementVNode("button", {
              class: "close-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "×")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("ol", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skilupKouseiData?.skilupPhaseList, (phase, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: phase.phaseId
                  }, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(index + 1), 1),
                    _createElementVNode("a", {
                      href: '#step' + (index + 1),
                      class: "txt1"
                    }, _toDisplayString(phase.phaseName), 9, _hoisted_10)
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("section", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skilupKouseiData?.skilupPhaseList, (phase, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: phase.phaseId
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", {
                          class: "anchor1",
                          id: 'step' + (index + 1)
                        }, null, 8, _hoisted_17),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("span", _hoisted_20, _toDisplayString(index + 1), 1)
                          ]),
                          _createElementVNode("h2", null, _toDisplayString(phase.phaseName), 1),
                          _createElementVNode("p", null, _toDisplayString(phase.phaseTitle), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_21,
                          _createElementVNode("span", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.getWatchedCount(phase)), 1),
                            _hoisted_24,
                            _createElementVNode("span", _hoisted_25, _toDisplayString(phase.phaseKouseiList.length), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDisplayedChapters(
                      phase.phaseKouseiList,
                      phase.isOpen
                    ), (chapter) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["item1", [
                      'item1',
                      {
                        active1:
                          _ctx.activeChapter?.phaseId === chapter.phaseId &&
                          _ctx.activeChapter?.chapterId === chapter.chapterId,
                      },
                    ]]),
                              key: chapter.chapterId,
                              onClick: ($event: any) => (
                      _ctx.showActiveChapter(phase, chapter, 'STEP' + (index + 1))
                    )
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("img", {
                                  src: 
                          _ctx.getCheckeImg(
                            _ctx.activeChapter?.phaseId ?? '',
                            _ctx.activeChapter?.chapterId ?? '',
                            chapter.phaseId,
                            chapter.chapterId,
                            chapter.isWatched
                          )
                        ,
                                  alt: ""
                                }, null, 8, _hoisted_29)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_30, _toDisplayString(chapter.chapterName), 1),
                                _createElementVNode("p", _hoisted_31, [
                                  _createElementVNode("span", null, _toDisplayString(chapter.chapterTitle), 1),
                                  _createTextVNode(" " + _toDisplayString(chapter.chapterComment), 1)
                                ])
                              ])
                            ], 10, _hoisted_28))
                          }), 128)),
                          (phase.phaseKouseiList.length > _ctx.defaultDispCnt)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass({ open1: phase.isOpen })
                              }, [
                                _createElementVNode("span", {
                                  class: "more_button1",
                                  onClick: ($event: any) => (_ctx.togglePhaseOpen(phase))
                                }, _hoisted_34, 8, _hoisted_32)
                              ], 2))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                (
              _ctx.iContentsDataFetched &&
              _ctx.activeChapter?.chapterId &&
              _ctx.contentsData.contentsId
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.activeStepName), 1),
                            _createElementVNode("h2", null, _toDisplayString(_ctx.activePhaseName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.activeChapter?.chapterName), 1),
                              _createElementVNode("h2", null, _toDisplayString(_ctx.activeChapter?.chapterTitle), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  id: "checkComplete",
                                  name: "",
                                  value: _ctx.activeChapter?.isWatched,
                                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateWatchedStatus(_ctx.activeChapter))),
                                  checked: _ctx.activeChapter?.isWatched
                                }, null, 40, _hoisted_43),
                                _hoisted_44
                              ])
                            ])
                          ]),
                          (_ctx.contentsData.contentsVideoList.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createVNode(_component_carousel, {
                                  class: "slide",
                                  autoplay: 0,
                                  pauseAutoplayOnHover: true,
                                  itemsToShow: _ctx.itemsToShow,
                                  wrapAround: true,
                                  transition: 500
                                }, {
                                  addons: _withCtx(() => [
                                    _createVNode(_component_navigation),
                                    _createVNode(_component_pagination)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsVideoList, (contentVideo) => {
                                      return (_openBlock(), _createBlock(_component_slide, {
                                        key: contentVideo.rowNo
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_46, [
                                            _createElementVNode("a", _hoisted_47, [
                                              (contentVideo.thumbnail)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: contentVideo.thumbnail,
                                                    alt: contentVideo.videoExp,
                                                    onClick: _withModifiers(($event: any) => (_ctx.openModal(contentVideo)), ["prevent"])
                                                  }, null, 8, _hoisted_48))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["itemsToShow"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_49, [
                            (_ctx.contentsData.contentsImgList.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  _createElementVNode("img", {
                                    src: `/${_ctx.contentsData.contentsImgList[0].imgPath}/${_ctx.contentsData.contentsImgList[0].imgName}`,
                                    alt: _ctx.contentsData.contentsImgList[0].imgExp
                                  }, null, 8, _hoisted_51)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "ql-editor",
                              innerHTML: _ctx.sanitizedContent
                            }, null, 8, _hoisted_52),
                            (_ctx.contentsData.contentsTempFileList.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  _hoisted_54,
                                  _createElementVNode("ul", _hoisted_55, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData?.contentsTempFileList, (tempFile) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: tempFile.rowNo
                                      }, [
                                        _createElementVNode("a", {
                                          href: `/${tempFile.tempFilePath}/${tempFile.tempFileName}`,
                                          class: "com_link1",
                                          target: "_blank",
                                          onClick: ($event: any) => (_ctx.regFileLinkClick(tempFile.tempFileName))
                                        }, _toDisplayString(tempFile.tempFileName), 9, _hoisted_56),
                                        _createElementVNode("a", {
                                          href: "#",
                                          class: "com_dl_button2",
                                          onClick: _withModifiers(($event: any) => (
                            _ctx.downloadFiles(
                              _ctx.contentsData.categoryId,
                              _ctx.contentsData.contentsId,
                              tempFile.tempFileName
                            )
                          ), ["prevent"])
                                        }, _hoisted_59, 8, _hoisted_57)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.contentsData.contentsLinkList.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                  _hoisted_61,
                                  _createElementVNode("ul", _hoisted_62, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData?.contentsLinkList, (contentsLink) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: contentsLink.rowNo
                                      }, [
                                        _createElementVNode("a", {
                                          href: contentsLink.url,
                                          class: "com_link1",
                                          target: "_blank",
                                          onClick: ($event: any) => (_ctx.regLinkClick(contentsLink.url)),
                                          rel: "noopener noreferrer"
                                        }, _toDisplayString(contentsLink.caption), 9, _hoisted_63)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_router_link, {
                              to: `/${_ctx.contentsData.detailPath}/categoryId/${
                      _ctx.contentsData.categoryId
                    }/contentsId/${_ctx.contentsData.contentsId}/ismodal/${true}`,
                              class: "button1",
                              target: "_blank",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (
                      _ctx.regLinkClick(
                        `/${_ctx.contentsData.detailPath}/categoryId/${
                          _ctx.contentsData.categoryId
                        }/contentsId/${_ctx.contentsData.contentsId}/ismodal/${true}`
                      )
                    ))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("詳細はこちら")
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      (
                _ctx.skilupKouseiData &&
                _ctx.skilupKouseiData.skilupCommentList.length > 0
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("div", _hoisted_68, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skilupKouseiData?.skilupCommentList, (comment, index) => {
                                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(comment), 1))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
          _createVNode(_component_FooterComponent)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BackToTop)
  ], 64))
}